import type { BrowserHistory } from 'history'
import { createBrowserHistory } from 'history'
import React from 'react'
import { Router } from 'react-router-dom'

type RouterProps = {
  basename?: string
  children: React.ReactNode
  history: BrowserHistory
}

export const CustomRouter = ({ basename, children, history }: RouterProps) => {
  const [state, setState] = React.useState({
    action: history.action,
    location: history.location,
  })

  React.useLayoutEffect(() => history.listen(setState), [history])

  return (
    <Router basename={basename} location={state.location} navigator={history} navigationType={state.action}>
      {children}
    </Router>
  )
}

export const history = createBrowserHistory()
